import * as yup from "yup";
import { portugues } from "_utils/validador";

yup.setLocale(portugues);

export const FiltrosAguardandoSchema = yup.object().shape({
  idsLotes: yup
    .array()
    .of(yup.number().typeError("ID deve ser numérico"))
    .optional()
    .nullable(),
  idsProcessos: yup
    .array()
    .of(yup.number().typeError("ID deve ser numérico"))
    .optional()
    .nullable(),
  idEmpresa: yup.number().optional().nullable(),
  idFornecedor: yup.number().optional().nullable(),
  periodo: yup.array().optional().nullable(),
  placa: yup.string().optional().nullable(),
  numeroNfRecibo: yup.string().optional().nullable(),
});
